import Loader from "@/components/loader/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase";
import {getRegionName} from "@/utils/functionsRegion";
import MaintenanceUploadMedia from "@/views/maintenance/maintenanceUploadMedia/MaintenanceUploadMedia.vue";

export default {
  name: "maintenanceCreateRequest",
  components: {
    Loader,
    ValidationProvider,
    ValidationObserver,
    MaintenanceUploadMedia
  },
  data() {
    return {
      loading: {
        page: true,
        create: false,
        media: false,
      },
      newMaintenanceRequest: {
        name: "",
        description: "",
        residentName: "",
        roomName: "",
        location: "",
        type: "QR Code",
        status: "new",
        icon: "qrcode"
      },
      maintenanceTypes: [],
      uploadKey: 0,
      facilityId: null
    }
  },
  async created() {
    this.loading.page = false;
    this.facilityId = this.$route.query.facilityId
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        return;
      }

      if(!this.facilityId) {
        this.$toast.open({
          type: "error",
          message: this.$t("Maintenance.CreateMaintenanceRequest.ScanQRCodeOneMoreTime")
        });
        return;
      }

      const isObjectValid = this.validateObject(this.newMaintenanceRequest);
      if(!isObjectValid) {
        this.$toast.open({
          type: "error",
          message: "The form contains invalid characters"
        });

        return;
      }

      try {
        this.loading.create = true;
        this.newMaintenanceRequest.facilityId = this.facilityId;

        await firebase
          .app()
          .functions(getRegionName())
          .httpsCallable("maintenance-createMaintenanceRequestByQRCode")({
            request: this.newMaintenanceRequest
          })
          .then(async () => {
            this.$toast.open({
              type: "success",
              message: "Maintenance request has been successfully created"
            });
            this.clearForm()
          }).catch((err) => {
            console.log(err)
            this.$toast.open({
              type: "error",
              message: this.$t("GeneralTranslations.UnhandledError")
            })
          }).finally(() => {
            this.loading.create = false;
          })
      } catch (err) {
        console.log(err)
        this.$toast.open({
          type: "error",
          message: this.$t("GeneralTranslations.UnhandledError")
        })
      }
    },
    validateField(input) {
      const regex = /^[a-zA-Zа-яА-ЯёЁіІїЇєЄ0-9\s.,'"\-!@#$%^&*()_+=[\]{}:;?]*$/u;
      return regex.test(input);
    },
    validateObject(obj: any) {
      for (const key in obj) {
        if (!this.validateField(obj[key])) {
          this.$toast.open({
            type: "error",
            message: `Field "${key}" is not valid.`
          })
          return false;
        }
      }
      return true;
    },
    onMaintenanceMediaBeforeUpload(){
      this.loading.media = true
    },
    onMaintenanceMediaUploaded(data){
      this.newMaintenanceRequest.id = data.id
      this.newMaintenanceRequest.media = data.media
      this.loading.media = false
    },
    clearForm() {
      this.newMaintenanceRequest.id = null
      this.newMaintenanceRequest.name = "";
      this.newMaintenanceRequest.description = "";
      this.newMaintenanceRequest.residentName = "";
      this.newMaintenanceRequest.roomName = "";
      this.newMaintenanceRequest.location = "";
      this.newMaintenanceRequest.media = []

      this.uploadKey += 1;
      this.$refs.form.reset();
      this.$refs.createMaintenanceRequestForm.reset();
    }
  }
}